import React from 'react';

import { List } from '../../../components';
import { ListContainer } from '../../../containers';
import { useRefreshPage } from '../../../hooks/useRefreshPage';
import MarketSetupListItem from './MarketSetupListItem';

const MarketSetupList = ({
	items: setups,
	refetch,
	customProps,
	customControls,
}) => {
	const [refreshPage, isRefreshing] = useRefreshPage(refetch);

	return (
		<List
			items={setups}
			listItemComponent={MarketSetupListItem}
			onRefresh={refreshPage}
			isRefreshing={isRefreshing}
			emptyListMessage="No market setups found"
			autoScrollTop={true}
			showControls={true}
			assembler={[]}
			removeTopMargin={true}
			customProps={customProps}
			customControls={customControls}
		/>
	);
};

export default ListContainer(MarketSetupList);
